
//import sass styles
import "./trackerbase-app-main.scss";

import angular from "angular";

import DependencyListBuilder from "tbClient/utility/DependencyListBuilder";

//import angular and libraries
import ngSanitize from "angular-sanitize";
import ngResource from "angular-resource";
import ngAnimate from "angular-animate";
import ngAria from "angular-aria";
import ngCookies from "angular-cookies";
import kendoDirectives from "tbClient/shims/kendoDirectives";

import uiBootstrap from "angular-ui-bootstrap";
import uiRouter from "@uirouter/angularjs";

import angularStorage from "angular-storage";
import angularJwt from "angular-jwt";
import oneLoginOidc from "tbClient/shims/oneLoginOidc";


// import kendo from "kendo";
// import "kendo.timezones";
//
// import moment from "moment-timezone";

//import our top-level view modules and directives

import TrackerBaseAppConfigurationModule from "tbClient/config/tb-app-config/TbAppConfigDataService";
import MainPageNavBarComponentModule from "tbClient/views/main-page/MainPageNavbar";
import MainPageFooterComponentModule from "tbClient/views/main-page/MainPageFooter";
import AppOverlayComponentModule from "tbClient/directives/app-overlay";
import TbLoginViewModule from "tbClient/views/tb-login-view/TbLoginView";
import TbAuthCallbackViewModule from "tbClient/views/auth-callback/AuthCallback";
import TrackerbaseSubscriptionAdminModule from "tbClient/views/trackerbase-admin/TbSubscriptionManagement";
import TrackerbaseReportsModule from "tbClient/views/trackerbase-reports/ReportsShell";
import TrackingCalendarModule from "tbClient/views/tracking-calendar-view/TrackingCalendarView";
import TrackingEventEditorModule from "tbClient/views/tracking-event-editor/TrackingEventEditor";
import TrackingEventSearchModule from "tbClient/views/tracking-event-search/TrackingEventSearch";
import TrackingTargetsViewModule from "tbClient/views/tracking-targets-view/TrackingTargetsView";
import ErrorPageViewModule from "tbClient/views/error-page";

import TrackerbaseAppConfiguration from "tbClient/TrackerbaseAppConfiguration";
import TrackerbaseAppInitialize from "tbClient/TrackerbaseAppInitialize";

const trackerbaseAppDependencies = DependencyListBuilder([
    TrackerbaseAppConfiguration.dependencies,
    TrackerbaseAppInitialize.dependencies,
    [
        ngSanitize,
        ngResource,
        ngAnimate,
        ngAria,
        ngCookies,
        uiRouter,
        uiBootstrap,
        kendoDirectives,
        angularJwt,
        angularStorage,
        oneLoginOidc,
        TrackerBaseAppConfigurationModule,
        MainPageNavBarComponentModule,
        MainPageFooterComponentModule,
        AppOverlayComponentModule,
        TbLoginViewModule,
        TbAuthCallbackViewModule,
        TrackerbaseSubscriptionAdminModule,
        TrackerbaseReportsModule,
        TrackingCalendarModule,
        TrackingEventEditorModule,
        TrackingEventSearchModule,
        TrackingTargetsViewModule,
        ErrorPageViewModule
    ]
]);

const trackerbaseAppName = "trackerbase-app";

// Declare app level module which depends on views, and components
export default angular
    .module(
        trackerbaseAppName,
        trackerbaseAppDependencies
    )
    .config(TrackerbaseAppConfiguration)
    .run(TrackerbaseAppInitialize)
    .name;





//////////////////
// WEBPACK FOOTER
// ./src/TrackerbaseApp.js
// module id = aIMh
// module chunks = 1